export default {"src":"/_next/static/media/paal_labs.4edf009c.svg","height":68,"width":194,"blurWidth":0,"blurHeight":0};